<div #chartLegend></div>
<div #chart [style.width.%]="chartData?.width" [style.height.px]="chartData?.height"></div>
